export const selectRsvp = ({rsvp}) => rsvp;
export const selectUserId = (state) => selectRsvp(state)?.userId ?? '';
export const selectEmailMd5 = (state) => selectRsvp(state)?.emailMd5 ?? '';
export const selectEmailSha256 = (state) => selectRsvp(state)?.emailSha256 ?? '';
export const selectInviteMethod = (state) => selectRsvp(state)?.inviteMethod;
export const selectIsSMSInvite = (state) => selectInviteMethod(state) === 'sms';
export const selectGuestEmail = (state) => selectRsvp(state)?.guestEmail ?? '';
export const selectName = (state) => selectRsvp(state)?.name ?? '';
export const selectPhone = (state) => selectRsvp(state)?.phone ?? '';
export const selectTotalAdults = (state) => selectRsvp(state)?.totalAdults ?? 0;
export const selectTotalKids = (state) => selectRsvp(state)?.totalKids ?? 0;
export const selectGuestOf = (state) => selectRsvp(state)?.guestOf ?? '';
export const selectHasRsvpd = (state) => selectRsvp(state)?.hasRsvpd ?? false;
export const selectNotifications = (state) => selectRsvp(state)?.notifications;
export const selectRsvpResponse = (state) => selectRsvp(state)?.rsvpResponse;
export const selectSmsOptIn = (state) => selectRsvp(state)?.smsOptIn ?? false;
export const selectCanShowMarketingOptIn = (state) =>
  selectRsvp(state)?.marketingContext?.can_show_marketing_consent ?? false;
export const selectMarketingOptin = (state) => selectRsvp(state)?.marketingContext?.optin ?? true;
export const selectMarketingContext = (state) => selectRsvp(state)?.marketingContext ?? {};
// From guestlist
export const selectRsvpByGuestlist = ({guestList}) => guestList?.rsvpDetails;
